import { Switch, Route, Redirect } from 'wouter';
import { AdminCockpit } from './Cockpit';
import { AdminClientes } from './Clientes';
import { AdminClienteDetalhe } from './ClienteDetalhe';
import { AdminFinanceiro } from './Financeiro';
import { AdminLeads } from './Leads';
import { AdminLeadDetalhe } from './LeadDetalhe';
import { AdminSuporte } from './Suporte';
import { AdminTicketDetalhe } from './TicketDetalhe';
import { AdminSaude } from './Saude';
import { AdminIndices } from './Indices';

/** Rotas do Console (renderizadas dentro da Shell unificada). */
export function AdminApp() {
  return (
    <Switch>
        <Route path="/admin/visao-geral" component={AdminCockpit} />
        <Route path="/admin/indices" component={AdminIndices} />
        <Route path="/admin/clientes" component={AdminClientes} />
        <Route path="/admin/clientes/:orgId" component={AdminClienteDetalhe} />
        <Route path="/admin/financeiro" component={AdminFinanceiro} />
        <Route path="/admin/leads" component={AdminLeads} />
        <Route path="/admin/leads/:id" component={AdminLeadDetalhe} />
        <Route path="/admin/suporte" component={AdminSuporte} />
        <Route path="/admin/suporte/:id" component={AdminTicketDetalhe} />
        <Route path="/admin/saude" component={AdminSaude} />
        {/* Compat com rotas antigas */}
        <Route path="/admin/metricas">
          <Redirect to="/admin/financeiro" />
        </Route>
        <Route path="/admin/intervencao">
          <Redirect to="/admin/clientes" />
        </Route>
        <Route path="/admin">
          <Redirect to="/admin/visao-geral" />
        </Route>
        <Route>
          <Redirect to="/admin/visao-geral" />
        </Route>
      </Switch>
  );
}
